<template>
  <div>
      <div class="comapny-sidebar">
          <div class="companies">
              <div>
                <router-link class="sidebar-icon" to="/admin/company">
                  <img src="@/assets/companies.svg" alt="company-icon" class="img">
                  <p>COMPANIES</p>
                </router-link>
              </div>
              <div>
                  <ul>
                      <li v-for="company in company" :key="company.id"><router-link :to="{ path: '/admin/company/' + company.id}"># {{ company.company_name }}</router-link></li>
                      <!-- <li># Poplat & Sons Ltd</li>
                      <li># Exxon Mobil</li> -->
                  </ul>
              </div>
          </div>
          <hr>
          <div class="messages">
              <div class="sidebar-icon">
                <img src="@/assets/message-icon.svg" alt="message-icon" class="img">
                <p>MESSAGES</p>
              </div>
              <div>
                  <ul>
                      <li>New Client Request</li>
                      <li>Existing Client Request</li>
                      <li>Complaints</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['company']
};
</script>

<style scoped lang="scss">
.comapny-sidebar {
    padding-left: 80px;
}
.sidebar-icon {
    display: flex;
    p {
        margin-left: 10px;
        // font-family: Sofia Pro;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 18px;
        color: #454141;
    }
}
.img {
    width: 20px;
}
.companies, .messages {
    ul {
        padding-left: 30px;
        li {
            margin-top: 22px;
            a {
                color: #454141;
            }
            .router-link-exact-active {
                color: #3887F6;
            }
        }
    }
}
hr {
    border: 0.5px solid #C4C4C4;
    max-width: 183.22px;
}
</style>
